/**
 * Everything the survey module needs from its host, in one place. Moving the folder
 * to another app means checking these values, nothing else.
 */

export const SURVEY_PAGE_TITLE = 'Student AI and Digital Learning Survey';

// The URL segment names the audience; the API names the survey.
export const SURVEYS = [
    { key: 'student', survey_code: 'ai_literacy_student', label: 'I am a student', pageTitle: SURVEY_PAGE_TITLE },
    { key: 'teacher', survey_code: 'ai_literacy_teacher', label: 'I am a teacher' },
];

// my-dq-api base, including /v1. REACT_APP_SURVEY_API overrides the app's usual API.
export const API_BASE = process.env.REACT_APP_SURVEY_API || process.env.REACT_APP_MYDQ_API || '';

// Hostnames that serve ONLY the survey (e.g. survey.example.org), comma-separated.
// On these, /student and /teacher are the surveys and / is a chooser.
// survey.localhost is always included so the subdomain can be tried locally.
export const SURVEY_HOSTS = ['survey.localhost', ...(process.env.REACT_APP_SURVEY_HOSTS || '')
    .split(',')
    .map((h) => h.trim().toLowerCase())
    .filter(Boolean)];

// On any other host, the surveys live under this path: /survey/student.
export const SURVEY_PATH_PREFIX = '/survey';
